<template>
    <div>
        <div>
            <ob1-select-field
                id="recovery-simulator-brands"
                v-model="selectedBrand"
                :elements="brands"
                :disabled="loadingBrand"
                :place-holder="messages.brandLabel"
                @input="onSelectBrand"
            />
            <ob1-progress-indicators v-if="loadingBrand" :size="25" type="undetermined" />
        </div>
        <div>
            <ob1-select-field
                id="recovery-simulator-models"
                v-model="selectedModel"
                :elements="models"
                :disabled="selectedBrand === undefined || loadingModel"
                :place-holder="messages.modelLabel"
                @input="onSelectModel"
            />
            <ob1-progress-indicators v-if="loadingModel" :size="25" type="undetermined" />
        </div>
    </div>
</template>

<script>
export default {
    name: "RecoverySimulatorByBrand",
    props: {
        shop: {
            type: String,
            required: true
        },
        category: {
            type: String,
            required: true
        },
        messages: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            selectedBrand: undefined,
            selectedModel: undefined,
            brands: [],
            models: [],
            loadingBrand: false,
            loadingModel: false,
        }
    },
    computed: {
    },
    mounted: function () {
        this.loadingBrand = true;
        this.fetchBrands(this.shop, this.category).then(result => {
                this.brands = result.highlightedBrands.concat("").concat(result.otherBrands);
            }
        ).catch(() => {
            this.brands = [];
            this.$emit('error');
        }).finally(() => {
                this.loadingBrand = false;
            }
        )
    },
    methods: {
        onSelectBrand() {
            this.loadingModel = true;
            this.fetchModelsByBrand(this.shop, this.category, this.selectedBrand).then(result => {
                this.models = result.models;
                this.selectedModel = undefined;
                this.$emit('selectModel', this.selectedBrand, this.selectedModel);
            }).catch(() => {
                this.models = [];
                this.selectedModel = undefined;
                this.$emit('error');
            }).finally(() => {
                    this.loadingModel = false;
                }
            )

        },
        onSelectModel(){
            this.$emit('selectModel', this.selectedBrand, this.selectedModel);
        },
        fetchBrands: function (shop, category) {
            let url = "/api/recovery/brands"
            return new Promise((resolve, reject) => {
                $.ajax({
                    method: "GET",
                    data: {
                        "shop": shop,
                        "category": category
                    },
                    url: url,
                    contentType: "application/json",
                    dataType: "json"
                }).done(result => {
                    resolve(result)
                }).fail(error => {
                    reject(error)
                })
            });
        },
        fetchModelsByBrand: function (shop, category, brand) {
            let url = "/api/recovery/models"
            return new Promise((resolve, reject) => {
                $.ajax({
                    method: "GET",
                    data: {
                        "shop": shop,
                        "category": category,
                        "brand": brand
                    },
                    url: url,
                    contentType: "application/json",
                    dataType: "json"
                }).done(result => {
                    resolve(result)
                }).fail(error => {
                    reject(error)
                })
            });
        }
    }
}
</script>

<style lang="scss">

</style>
